import Toast from '@/lib/toast'
import moment from 'moment'
import polylabel from 'polylabel'
import ApplicationConfig from '../../lib/application-config'
import connectNaviClient from '../../lib/connect-client/connect-navi-client'
import * as Constants from '../../lib/constants'
import * as FieldImport from '../../lib/field-import'
import router from '../../router'
import UTCDateTime from '../../lib/utc-datetime'
import store from '../index'
import * as Types from '../mutation-types'
import i18n from '../../lib/i18n'

import UserInfo from '@/lib/user-info'
import Planting from '@/lib/planting'
import Geo from '@/lib/geo'
import TaskPolygons from '@/lib/task/task-polygons'
//import geo from 'echarts/src/coord/geo/Geo' // テストが通らないので、コメントアウトしました(funami)

const turf = require('@turf/turf')

const state = {
  fields: [],
  currentField: null,
  currentFieldGeoJson: null,
  currentFieldElevationMap: null,
  countTasksInCurrentField: 0,

  /** @deprecated */
  currentFieldTasks: [],

  nowListingFields: false,

  tasks: [],
  taskNames: [],
  currentTask: null,

  // FIXME currentTask系のものは、一つのオブジェクトにまとめたい
  currentTaskPolygonGeoJson: null,
  currentTaskAllPointsFeature: turf.multiPoint([[0, 0, 0]]),

  currentTaskAltitudes: [],
  currentTaskMaxAltitude: 0,
  currentTaskMinAltitude: 0,

  currentTaskEffectiveSpeed: 0,

  currentTaskSpeeds: [],
  currentTaskMaxSpeed: 0,
  currentTaskMinSpeed: 0,
  // currentTaskWeatherInfo: null,
  currentTaskWeatherInfoFromOpenMeteo: null,

  currentTaskGnssNumOfSatellites: [],
  currentTaskMaxGnssNumOfSatellites: 0,
  currentTaskMinGnssNumOfSatellites: 0,

  currentTaskGnssStatus: [],
  currentTaskMaxGnssStatus: 0,
  currentTaskMinGnssStatus: 0,

  currentTaskGuidanceErrors: [],
  currentTaskMaxGuidanceErrors: 0,
  currentTaskMinGuidanceErrors: 0,

  currentTaskGuidanceHeadingErrors: [],
  currentTaskMaxGuidanceHeadingErrors: 0,
  currentTaskMinGuidanceHeadingErrors: 0,

  currentTaskSlants: [],
  currentTaskMaxSlant: 0,
  currentTaskMinSlant: 0,

  fieldGeoJsons: {},

  currentTaskPolygons: new TaskPolygons(),

  refLines: [],
  currentRefLine: null,
  currentRefLineGeoJson: null,

  availableOperationTypes: [],

  fieldListViewMode: Constants.LIST_VIEW_MODE_CARD,
  taskListViewMode: Constants.LIST_VIEW_MODE_LIST,

  paginationInfos: {
    tasks: {
      totalPages: 1,
    },
    currentFieldTasks: {
      totalPages: 1,
    },
    fields: {
      totalPages: 1,
    },
    refLines: {
      totalPages: 1,
    },
  },

  pagingOptions: {
    tasks: {
      page: 0,
      pageSize: Constants.DEFAULT_LIST_PAGE_SIZE,
      listingUser: Constants.TASK_LIST_LISTING_USER_ALL,
    },
    currentFieldTasks: {
      page: 0,
      pageSize: Constants.DEFAULT_LIST_PAGE_SIZE,
    },
    fields: {
      page: 0,
      pageSize: Constants.DEFAULT_LIST_PAGE_SIZE,
      listingUser: Constants.TASK_LIST_LISTING_USER_ALL,
    },
    refLines: {
      page: 0,
      pageSize: Constants.DEFAULT_LIST_PAGE_SIZE,
    },
  },

  sortOptions: {
    fields: {
      key: Constants.SortOrder.Field.Name.keyName,
      direction: Constants.SortOrder.Field.Name.direction,
    },
  },

  fieldImport: {
    hideMap: true,
  },

  dateFilterRange: '',
  filterDateFrom: '',
  filterDateTo: '',
  selectPickerType: Constants.DATE_PICKER_TYPE_MONTH,

  currentFilter: null,

  centroidOfUserFields: null,

  plantings: [],

  observations: {
    pf: [],
    at: [],
  },

  showFieldPrint: false,

}

const getters = {
  fields: state => state.fields,
  currentField: state => state.currentField,
  currentFieldGeoJson: state => state.currentFieldGeoJson,
  currentFieldElevationMap: state => state.currentFieldElevationMap,

  countTasksInCurrentField: state => state.countTasksInCurrentField,

  /** @deprecated */
  currentFieldTasks: state => state.currentFieldTasks,

  nowListingFields: state => state.nowListingFields,

  tasks: state => state.tasks,
  taskNames: state => state.taskNames,
  currentTask: state => state.currentTask,

  currentTaskPolygonGeoJson: state => state.currentTaskPolygonGeoJson,
  currentTaskAllPointsFeature: state => state.currentTaskAllPointsFeature,

  currentTaskAltitudes: state => state.currentTaskAltitudes,
  currentTaskMaxAltitude: state => state.currentTaskMaxAltitude,
  currentTaskMinAltitude: state => state.currentTaskMinAltitude,

  currentTaskEffectiveSpeed: state => state.currentTaskEffectiveSpeed,

  currentTaskSpeeds: state => state.currentTaskSpeeds,
  currentTaskMaxSpeed: state => state.currentTaskMaxSpeed,
  currentTaskMinSpeed: state => state.currentTaskMinSpeed,
  // currentTaskWeatherInfo: state => state.currentTaskWeatherInfo,
  currentTaskWeatherInfoFromOpenMeteo: state => state.currentTaskWeatherInfoFromOpenMeteo,

  currentTaskGnssNumOfSatellites: state => state.currentTaskGnssNumOfSatellites,
  currentTaskMaxGnssNumOfSatellites: state => state.currentTaskMaxGnssNumOfSatellites,
  currentTaskMinGnssNumOfSatellites: state => state.currentTaskMinGnssNumOfSatellites,

  currentTaskGnssStatus: state => state.currentTaskGnssStatus,
  currentTaskMaxGnssStatus: state => state.currentTaskMaxGnssStatus,
  currentTaskMinGnssStatus: state => state.currentTaskMinGnssStatus,

  currentTaskGuidanceErrors: state => state.currentTaskGuidanceErrors,
  currentTaskMaxGuidanceErrors: state => state.currentTaskMaxGuidanceErrors,
  currentTaskMinGuidanceErrors: state => state.currentTaskMinGuidanceErrors,

  currentTaskGuidanceHeadingErrors: state => state.currentTaskGuidanceHeadingErrors,
  currentTaskMaxGuidanceHeadingErrors: state => state.currentTaskMaxGuidanceHeadingErrors,
  currentTaskMinGuidanceHeadingErrors: state => state.currentTaskMinGuidanceHeadingErrors,

  currentTaskSlants: state => state.currentTaskSlants,
  currentTaskMaxSlant: state => state.currentTaskMaxSlant,
  currentTaskMinSlant: state => state.currentTaskMinSlant,

  currentTaskPolygons: state => state.currentTaskPolygons,

  availableOperationTypes: state => state.availableOperationTypes,

  fieldListViewMode: state => state.fieldListViewMode,
  taskListViewMode: state => state.taskListViewMode,

  paginationInfos: state => state.paginationInfos,
  pagingOptions: state => state.pagingOptions,

  fieldImport: state => state.fieldImport,
  dateFilterRange: state => state.dateFilterRange,
  filterDateFrom: state => state.filterDateFrom,
  filterDateTo: state => state.filterDateTo,
  selectPickerType: state => state.selectPickerType,

  refLines: state => state.refLines,
  currentRefLine: state => state.currentRefLine,
  currentRefLineGeoJson: state => state.currentRefLineGeoJson,
  currentFilter: state => state.currentFilter,

  centroidOfUserFields: state => state.centroidOfUserFields,

  plantings: state => state.plantings,

  observations: state => state.observations,

  showFieldPrint: state => state.showFieldPrint,


  sortOptions: state => state.sortOptions,
}

const mutations = {
  [Types.SET_SHOW_FIELD_PRINT](state, isShow) {
    state.showFieldPrint = isShow
  },
  [Types.LIST_FILEDS_SUCCESS](state, fields) {
    state.fields = fields
    state.fieldGeoJsons = {}
    for (let i = 0; i < fields.length; i++) {
      const f = fields[i]
      const geoJson = JSON.parse(f.geoJson)
      state.fieldGeoJsons[f.id] = geoJson
    }
    state.nowListingFields = false
  },

  [Types.SET_FIELD_DETAIL](state, fieldDetail) {
    state.currentField = fieldDetail.field
    state.currentFieldGeoJson = fieldDetail.geoJson
  },

  [Types.LIST_TASKS_SUCCESS](state, tasks) {
    state.tasks = tasks
    state.taskNames = []
    for (let i = 0; i < state.tasks.length; i++) {
      state.taskNames.push(state.tasks[i].name)
    }
  },

  [Types.CLEANUP_CURRENT_FILED](state) {
    state.nowListingFields = true
    state.currentField = null
    state.currentFieldGeoJson = null
  },

  [Types.SHOW_TASK_DETAIL](state, taskDetail) {
    state.currentTask = taskDetail.task
    state.currentTaskPolygonGeoJson = taskDetail.polygonGeoJson
    state.currentTaskAllPointsFeature = taskDetail.pointAllFeature
    state.currentTaskAltitudes = taskDetail.altitudes
    state.currentTaskMaxAltitude = taskDetail.maxAltitude
    state.currentTaskMinAltitude = taskDetail.minAltitude
    state.currentTaskSpeeds = taskDetail.speeds
    state.currentTaskMaxSpeed = taskDetail.maxSpeed
    state.currentTaskMinSpeed = taskDetail.minSpeed
    state.currentTaskGnssNumOfSatellites = taskDetail.gnssNumOfSatellites
    state.currentTaskMaxGnssNumOfSatellites = taskDetail.maxGnssNumOfSatellites
    state.currentTaskMinGnssNumOfSatellites = taskDetail.minGnssNumOfSatellites
    state.currentTaskGnssStatus = taskDetail.gnssStatus
    state.currentTaskMaxGnssStatus = taskDetail.maxGnssStatus
    state.currentTaskMinGnssStatus = taskDetail.minGnssStatus
    state.currentTaskGuidanceErrors = taskDetail.guidanceErrors
    state.currentTaskMaxGuidanceErrors = taskDetail.maxGuidanceErrors
    state.currentTaskMinGuidanceErrors = taskDetail.minGuidanceErrors
    state.currentTaskGuidanceHeadingErrors = taskDetail.guidanceHeadingErrors
    state.currentTaskMaxGuidanceHeadingErrors = taskDetail.maxGuidanceHeadingErrors
    state.currentTaskMinGuidanceHeadingErrors = taskDetail.minGuidanceHeadingErrors
    state.currentTaskSlants = taskDetail.slants
    state.currentTaskMaxSlant = taskDetail.maxSlant
    state.currentTaskMinSlant = taskDetail.minSlant
    state.currentTaskEffectiveSpeed = taskDetail.effectiveSpeed

    state.currentTaskPolygons = taskDetail.taskPolygons
  },

  [Types.SET_CURRENT_FIELD_TASKS](state, tasks) {
    state.currentFieldTasks = tasks
  },

  [Types.UPDATE_PAGING_OPTIONS_OF_CURRENT_FIELD_TASKS](state, pagingOptions) {
    state.pagingOptions.currentFieldTasks.page = pagingOptions.page
    state.pagingOptions.currentFieldTasks.pageSize = pagingOptions.pageSize
  },

  [Types.CLEANUP_CURRENT_TASK](state) {
    state.currentField = null
    state.currentFieldGeoJson = null
    state.currentTask = null
  },

  [Types.SET_PAGINATION_INFO](state, paginationInfoAndType) {
    const type = paginationInfoAndType.type
    if (type === Constants.TASKS_PAGINATION_INFO_TYPE) {
      state.paginationInfos.tasks = paginationInfoAndType.info
    } else if (type === Constants.CURRENT_FIELD_TASKS_PAGINATION_INFO_TYPE) {
      state.paginationInfos.currentFieldTasks = paginationInfoAndType.info
    } else if (type === Constants.FIELDS_PAGINATION_INFO_TYPE) {
      state.paginationInfos.fields = paginationInfoAndType.info
    } else if (type === Constants.REFLINES_PAGINATION_INFO_TYPE) {
      state.paginationInfos.refLines = paginationInfoAndType.info
    }
  },

  [Types.UPDATE_PAGING_OPTIONS_OF_TASK_LIST](state, pagingOptions) {
    state.pagingOptions.tasks.page = pagingOptions.page
    state.pagingOptions.tasks.pageSize = pagingOptions.pageSize
  },

  [Types.UPDATE_PAGING_OPTIONS_OF_FIELD_LIST](state, pagingOptions) {
    state.pagingOptions.fields.page = pagingOptions.page
    state.pagingOptions.fields.pageSize = pagingOptions.pageSize
  },

  [Types.UPDATE_LISTING_USER_OF_TASK_LIST](state, listingUser) {
    state.pagingOptions.tasks.listingUser = listingUser
    state.pagingOptions.tasks.page = 0
  },

  [Types.UPDATE_TASK_NAME_IN_LIST](state, updateTaskNameRequest) {
    state.taskNames[updateTaskNameRequest.index] = updateTaskNameRequest.value
  },

  [Types.UPDATE_FIELD_NAME_IN_LIST](state, updateRequest) {
    const index = updateRequest.index
    const fieldName = updateRequest.value
    state.fields[index].name = fieldName
  },

  [Types.SET_CURRENT_FIELD](state, field) {
    state.currentField = field
    for (let i = 0; i < state.fields.length; i++) {
      const f = state.fields[i]
      if (f.id === field.id) {
        state.fields[i] = field
        break
      }
    }
  },

  [Types.SET_COUNT_TASKS_IN_CURRENT_FIELD](state, count) {
    state.countTasksInCurrentField = count
  },

  [Types.SET_CURRENT_TASK](state, task) {
    state.currentTask = task
    for (let i = 0; i < state.tasks.length; i++) {
      const t = state.tasks[i]
      if (t.id === task.id) {
        state.tasks[i] = task
        break
      }
    }
  },

  [Types.SET_AVAILABLE_OPERATION_TYPES](state, types) {
    state.availableOperationTypes = types
  },

  [Types.SET_LIST_VIEW_MODE](state, data) {
    if (data.view === 'field') {
      state.fieldListViewMode = data.mode
    } else if (data.view === 'task') {
      state.taskListViewMode = data.mode
    }
  },

  /** @deprecated */
  [Types.SHOW_TASKS_IN_FILED_WITH_MAP](state, fieldAndGeoJson) {
    let field = fieldAndGeoJson.field
    let geoJson = fieldAndGeoJson.geoJson
    state.currentField = field
    state.currentFieldGeoJson = state.fieldGeoJsons[field.geoInfoKey]
    state.currentTask = undefined
    state.currentTaskLineStringGeoJson = undefined
    state.currentTaskPolygonGeoJson = geoJson
  },

  [Types.FIELD_IMPORT_HIDE_MAP](state, boolValue) {
    state.fieldImport.hideMap = boolValue
  },

  [Types.SET_DATE_FILTER_RANGE](state, params) {
    if (params.filterDateFrom === '' && params.filterDateTo === '') {
      state.dateFilterRange = ''
      state.filterDateFrom = ''
      state.filterDateTo = ''
      state.selectPickerType = Constants.DATE_PICKER_TYPE_MONTH
    } else {
      state.dateFilterRange = params.filterDateFrom + '〜' + params.filterDateTo
      state.filterDateFrom = params.filterDateFrom
      state.filterDateTo = params.filterDateTo
      state.selectPickerType = params.selectPickerType
    }
  },

  [Types.SET_REFLINES](state, refLines) {
    state.refLines = refLines
  },
  [Types.UPDATE_PAGING_OPTIONS_OF_REFLINES_LIST](state, pagingOptions) {
    state.pagingOptions.refLines.page = pagingOptions.page
    state.pagingOptions.refLines.pageSize = pagingOptions.pageSize
  },
  [Types.SET_CURRENT_REFLINE](state, item) {
    state.currentRefLine = item.item
    state.currentRefLineGeoJson = item.geoJson
  },
  [Types.SET_CURRENT_FILTER](state, filter) {
    state.currentFilter = filter
  },

  [Types.SET_CURRENT_TASK_WEATHER_INFO_FROM_OPEN_METEO](state, weatherInfo) {
    state.currentTaskWeatherInfoFromOpenMeteo = weatherInfo
  },

  [Types.SET_CENTROID_OF_USER_FIELDS](state, point) {
    state.centroidOfUserFields = point
  },

  [Types.SET_PLANTINGS](state, plantings) {
    state.plantings = plantings.map(remote => new Planting(remote))
  },

  [Types.SET_PF_OBSERVATIONS](state, points) {
    state.observations.pf = points
  },
  [Types.SET_AT_OBSERVATIONS](state, points) {
    state.observations.at = points
  },

  [Types.SET_LIST_FIELD_SORT_OPTIONS](state, item) {
    state.sortOptions.fields.key = item.key
    state.sortOptions.fields.direction = item.direction
  },

  [Types.SET_CURRENT_FIELD_ELEVATION_MAP](state, elevationMap) {
    state.currentFieldElevationMap = elevationMap
  },

  [Types.CLEANUP_CURRENT_FILED_ELEVATION_MAP](state) {
    state.currentFieldElevationMap = null
  },
}

const actions = {
  setShowFieldPrint({ commit }, isShow) {
    commit(Types.SET_SHOW_FIELD_PRINT, isShow)
  },
  /* navi2へ
  deleteField: function({ commit }, field) {
    connectNaviClient.deleteField(field).then(response => {
      store.dispatch('initFields2')
    })
  },
  */
  /* navi2へ
  createField: function({ commit }, params) {
    connectNaviClient
      .importFields(params.request)
      .then(response => {
        router.push({
          name: 'FieldListAsList',
        })
        store.dispatch('setListViewMode', {
          view: 'field',
          mode: Constants.LIST_VIEW_MODE_LIST,
        })
        Toast.i18nSuccess('customFieldCreateWithMapCreateFinishedMessage', {
          fieldName: params.fieldName,
        })
        store.dispatch('initFields2')
      })
      .catch(error => {
        console.error(error)
        Toast.i18nError('customFieldCreateWithMapCreateErrorMessage', {
          fieldName: params.fieldName,
        })
      })
  },
  */
  /* navi2へ
  importRefLines: function({ commit }, request) {
    connectNaviClient
      .importRefLines(request)
      .then(response => {
        const result = response.data
        Toast.i18nSuccess('customRefLineImportFinishedMessage', {
          count: result.count,
        })
        store.dispatch('initRefLines')
      })
      .catch(error => {
        console.error(error)
        Toast.i18nError('customRefLineImportErrorMessage')
      })
  },
  */
  /* navi2へ
  importFields: function({ commit }, request) {
    connectNaviClient
      .importFields(request)
      .then(response => {
        const result = response.data
        store.dispatch('setListViewMode', {
          view: 'field',
          mode: Constants.LIST_VIEW_MODE_LIST,
        })
        Toast.i18nSuccess('customFieldImportFinishedMessage', {
          count: result.count,
        })
        store.dispatch('initFields2')
      })
      .catch(error => {
        console.error(error)
        Toast.i18nError('customFieldImportErrorMessage')
      })
  },
  */

  initFieldImport: function({ commit }) {
    commit(Types.FIELD_IMPORT_HIDE_MAP, true)
  },
  /* navi2へ
  uploadGeoFile: function({ commit }, request) {
    let importedGeoJson = null
    let importFeatures = request.importFeatures
    let propertyKeys = request.geoFilePropertyKeys
    let geoFileInfo = request.geoFileInfo
    const file = request.geoFile
    let googleMap = request.googleMap
    const params = {
      encoding: request.encoding,
    }

    connectNaviClient
      .uploadGeoFile(file, params)
      .then(response => {
        importedGeoJson = response.data
        commit(Types.FIELD_IMPORT_HIDE_MAP, false)

        // google map
        googleMap.$mapPromise.then(map => {
          map.setTilt(0)

          for (let i = 0; i < importedGeoJson.features.length; i++) {
            const feature = importedGeoJson.features[i]
            feature.properties[FieldImport.GEOJSON_PROPERTY_FIELD_ENABLED] = FieldImport.YES
            feature.properties[FieldImport.GEOJSON_PROPERTY_FIELD_ID] = i
            importFeatures.push(feature)
            let center = []
            const coordinates = feature.geometry.coordinates
            if (request.mode === Constants.IMPORT_MODE.FIELDS) {
              center = polylabel(coordinates, 1.0)
            } else {
              // reflineはstartpointにマーカーを立てる
              const startPoint = coordinates[0]
              center.push(startPoint[0])
              center.push(startPoint[1])
            }

            const marker = {
              import: true,
              id: feature.properties[FieldImport.GEOJSON_PROPERTY_FIELD_ID],
              position: { lat: center[1], lng: center[0] },
            }
            request.markers.push(marker)

            for (let prop in feature.properties) {
              if (!propertyKeys.includes(prop)) {
                if (!FieldImport.canIgnoreGeoJsonProperty(prop)) {
                  propertyKeys.push(prop)
                }
              }
            }
          }
          map.data.addGeoJson(importedGeoJson)
          let bounds = new google.maps.LatLngBounds()
          map.data.forEach(feature => {
            feature.getGeometry().forEachLatLng(latlng => {
              bounds.extend(latlng)
            })
          })
          map.data.addListener('click', function(event) {
            request.showInfoWindow(event)
          })

          let strokeWeight = 2
          if (request.mode === Constants.IMPORT_MODE.REFLINES) {
            strokeWeight = 4
          }
          map.data.setStyle(feature => {
            const isFieldImport = feature.getProperty(FieldImport.GEOJSON_PROPERTY_FIELD_ENABLED)
            if (isFieldImport === FieldImport.YES) {
              return {
                strokeColor: Constants.FIELD_CURRENT_LINE_COLOR,
                fillColor: Constants.FIELD_FILL_COLOR,
                fillOpacity: Constants.FIELD_FILL_OPACITY,
                strokeWeight: strokeWeight,
              }
            } else {
              return {
                strokeColor: FieldImport.FIELD_DISABLED_FILL_COLOR,
                fillColor: FieldImport.FIELD_DISABLED_FILL_COLOR,
                fillOpacity: Constants.FIELD_FILL_OPACITY,
                strokeWeight: strokeWeight,
              }
            }
          })
          geoFileInfo.count = importFeatures.length
          map.fitBounds(bounds)
        })
        // end
      })
      .catch(error => {
        const responseData = error.response.data
        console.error(responseData)
        commit(Types.FIELD_IMPORT_HIDE_MAP, true)
        if (responseData.code === Constants.APIErrorCode.MULTIPOLYGON_IMPORT_ERROR) {
          Toast.i18nError('customMultiPolygonImportError')
        } else {
          Toast.i18nError('customFieldUploadErrorMessage')
        }
      })
  },
*/
  setListViewMode({ commit }, data) {
    commit(Types.SET_LIST_VIEW_MODE, data)
  },
  /* navi2へ
  listOperationAvailableTypes({ commit }) {
    connectNaviClient.listOperationAvailableTypes().then(response => {
      commit(Types.SET_AVAILABLE_OPERATION_TYPES, response.data)
    })
  },

  initPlantings({ commit }) {
    connectNaviClient.listPlantings().then(response => {
      const plantings = response.data
      commit(Types.SET_PLANTINGS, plantings)
    })
  },

  createPlanting({ commit }, params) {
    connectNaviClient.createPlanting(params.request).then(response => {
      if (params.onSuccess) {
        params.onSuccess(response.data)
      }
    })
  },

  updatePlanting({ commit }, params) {
    connectNaviClient.updatePlanting(params.request).then(response => {
      if (params.onSuccess) {
        params.onSuccess(response.data)
      }
    })
  },

  deletePlanting({ commit }, params) {
    connectNaviClient.deletePlanting(params.request).then(response => {
      if (params.onSuccess) {
        params.onSuccess(response.data)
      }
    })
  },
  */
  /* navi2へ
  updateTaskMetaData({ commit }, updateRequest) {
    connectNaviClient
      .updateTaskMetaData(updateRequest)
      .then(response => {
        const updatedTask = response.data
        commit(Types.SET_CURRENT_TASK, updatedTask)
      })
      .catch(error => {
        console.error(error)
      })
  },
  */

  /** @deprecated */
  updatePagingOfCurrentFieldTasks({ commit }, pagingOptions) {
    commit(Types.UPDATE_PAGING_OPTIONS_OF_CURRENT_FIELD_TASKS, pagingOptions)
    const currentField = store.getters.currentField
    store.dispatch('getTasksInField2', currentField)
  },

  /* navi2へ
  updateFieldMetaData({ commit }, updateRequest) {
    connectNaviClient
      .updateFieldMetaData(updateRequest)
      .then(response => {
        const updatedField = response.data
        commit(Types.SET_CURRENT_FIELD, updatedField)
      })
      .catch(error => {
        console.error(error)
      })
  },
  */

  /** @deprecated */
  updateFieldNameInList({ commit }, updateRequest) {
    commit(Types.UPDATE_FIELD_NAME_IN_LIST, updateRequest)
    const index = updateRequest.index
    const targetField = state.fields[index]
    const request = {
      name: updateRequest.value,
    }
    connectNaviClient
      .updateFieldMetaData(targetField, request)
      .then(response => {
// TEMP         console.log(response)
      })
      .catch(error => {
        console.error(error)
      })
  },

  // 2024.01.24 OpenMeteo対応により廃止
  // @Deprecated
  getCurrentTaskWeatherInfo({ commit }, task) {
    // Taskに紐づく圃場がある場合にのみ天候情報を取得
    // if (task.fieldItemKey) {
    //   connectNaviClient
    //     .getCurrentTaskWeatherInfo(task)
    //     .then(response => {
    //       const weatherInfo = response.data
    //       commit(Types.SET_CURRENT_TASK_WEATHER_INFO, weatherInfo)
    //     })
    //     .catch(error => {
    //       console.error(error)
    //     })
    // } else {
    //   commit(Types.SET_CURRENT_TASK_WEATHER_INFO, null)
    // }
  },
  /* navi2へ
  showTaskDetail2({ commit }, params) {
    commit(Types.SET_CURRENT_TASK_WEATHER_INFO, null)
    // 1. Taskに紐づくFieldのGeoJSONを取得
    const task = params.task
    const fieldGeoInfoKey = task.fieldItemKey
    const allFields = state.fields
    let fieldOfTask = null
    for (let i = 0; i < allFields.length; i++) {
      let f = allFields[i]
      if (f.geoInfoKey === fieldGeoInfoKey) {
        fieldOfTask = f
      }
    }
    if (fieldOfTask) {
      store.dispatch('setFieldDetail2', fieldOfTask)
      store.dispatch('growGetWeatherInfoOfField', { field: fieldOfTask, dateTime: task.startTime })
    }

    // 2. TaskのGeoJSON取得
    connectNaviClient
      .getTaskInfo(task)
      .then(response => {
        const polygonGeoJson = JSON.parse(response.data.geoJson)
        const effectiveSpeed = response.data.effectiveSpeed
        let altitudes = []
        let maxAltitude = 0
        let minAltitude = 0

        let speeds = []
        let maxSpeed = 0
        let minSpeed = 0
        let pointAllFeature = turf.multiPoint([[0, 0, 0]])

        let gnssNumOfSatellites = []
        let maxGnssNumOfSatellites = 0
        let minGnssNumOfSatellites = 0

        let gnssStatus = []
        let maxGnssStatus = 0
        let minGnssStatus = 0

        let guidanceErrors = []
        let maxGuidanceErrors = 0
        let minGuidanceErrors = 0

        let guidanceHeadingErrors = []
        let maxGuidanceHeadingErrors = 0
        let minGuidanceHeadingErrors = 0

        let slants = []
        let maxSlant = 0
        let minSlant = 0

        let taskPolygons = new TaskPolygons()

        // GeoJson解析
        turf.featureEach(polygonGeoJson, function(currentFeature, currentIndex) {
          let currentProperties = currentFeature.properties
          let propName = currentProperties.name
          //console.log(propName)
          if (propName === Constants.GeoJsonProp.POINTS_ALL_ALTITUDES) {
            // 高さチャート描画用
            altitudes = currentProperties.values
            maxAltitude = currentProperties.max
            minAltitude = currentProperties.min
          } else if (propName.indexOf(Constants.GeoJsonProp.POLYGON_ALTITUDE_PREFIX) !== -1) {
            // 高さポリゴン
            const layerIndex = propName.slice(-1)
            const color = Constants.TRACK_COLORS[layerIndex]
            currentFeature.properties.color = color
            currentFeature.properties.layerIndex = layerIndex
            Geo.add0Point(currentFeature.geometry.coordinates)
            taskPolygons.altitudesPolygon.features.push(currentFeature)
          } else if (propName === Constants.GeoJsonProp.POINTS_ALL_SPEEDS) {
            // スピードチャート描画用
            speeds = currentProperties.values
            maxSpeed = currentProperties.max
            minSpeed = currentProperties.min
          } else if (propName.indexOf(Constants.GeoJsonProp.POLYGON_SPEED_PREFIX) !== -1) {
            // スピードポリゴン
            const layerIndex = propName.slice(-1)
            const color = Constants.TRACK_COLORS[layerIndex]
            currentFeature.properties.color = color
            currentFeature.properties.layerIndex = layerIndex
            Geo.add0Point(currentFeature.geometry.coordinates)
            taskPolygons.speedsPolygon.features.push(currentFeature)
          } else if (propName === Constants.GeoJsonProp.POINTS_ALL_GNSS_NUM_OF_SATELLITES) {
            // 測位衛星数チャート描画用
            gnssNumOfSatellites = currentProperties.values
            maxGnssNumOfSatellites = currentProperties.max
            minGnssNumOfSatellites = currentProperties.min
          } else if (propName.indexOf(Constants.GeoJsonProp.POLYGON_GNSS_NUM_OF_SATELLITES_PREFIX) !== -1) {
            // 測位衛星数ポリゴン
            const layerIndex = propName.slice(-1)
            const color = Constants.TRACK_COLORS[layerIndex]
            currentFeature.properties.color = color
            currentFeature.properties.layerIndex = layerIndex
            Geo.add0Point(currentFeature.geometry.coordinates)
            taskPolygons.gnssNumOfSatellitesPolygon.features.push(currentFeature)
          } else if (propName === Constants.GeoJsonProp.POINTS_ALL_GNSS_STATUS) {
            // GNSS状態チャート描画用
            gnssStatus = currentProperties.values
            maxGnssStatus = currentProperties.max
            minGnssStatus = currentProperties.min
          } else if (propName.indexOf(Constants.GeoJsonProp.POLYGON_GNSS_STATUS_PREFIX) !== -1) {
            // GNSS状態ポリゴン
            const layerIndex = propName.slice(-1)
            const color = Constants.TRACK_COLORS[layerIndex]
            currentFeature.properties.color = color
            currentFeature.properties.layerIndex = layerIndex
            Geo.add0Point(currentFeature.geometry.coordinates)
            taskPolygons.gnssStatusPolygon.features.push(currentFeature)
          } else if (propName === Constants.GeoJsonProp.POINTS_ALL_GUIDANCE_ERROR) {
            // 左右ずれチャート描画用
            guidanceErrors = currentProperties.values
            maxGuidanceErrors = currentProperties.max
            minGuidanceErrors = currentProperties.min
          } else if (propName.indexOf(Constants.GeoJsonProp.POLYGON_GUIDANCE_ERROR_PREFIX) !== -1) {
            // 左右ずれポリゴン
            const layerIndex = propName.slice(-1)
            const color = Constants.TRACK_COLORS[layerIndex]
            currentFeature.properties.color = color
            currentFeature.properties.layerIndex = layerIndex
            Geo.add0Point(currentFeature.geometry.coordinates)
            taskPolygons.guidanceErrorsPolygon.features.push(currentFeature)
          } else if (propName === Constants.GeoJsonProp.POINTS_ALL_GUIDANCE_HEADING_ERROR) {
            // 方位ずれチャート描画用
            guidanceHeadingErrors = currentProperties.values
            maxGuidanceHeadingErrors = currentProperties.max
            minGuidanceHeadingErrors = currentProperties.min
          } else if (propName.indexOf(Constants.GeoJsonProp.POLYGON_GUIDANCE_HEADING_ERROR_PREFIX) !== -1) {
            // 方位ずれポリゴン
            const layerIndex = propName.slice(-1)
            const color = Constants.TRACK_COLORS[layerIndex]
            currentFeature.properties.color = color
            currentFeature.properties.layerIndex = layerIndex
            Geo.add0Point(currentFeature.geometry.coordinates)
            taskPolygons.guidanceHeadingErrorsPolygon.features.push(currentFeature)
          } else if (propName === Constants.GeoJsonProp.POINTS_ALL_SLANT) {
            // 傾斜度チャート描画用
            slants = currentProperties.values
            maxSlant = currentProperties.max
            minSlant = currentProperties.min
          } else if (propName.indexOf(Constants.GeoJsonProp.POLYGON_SLANT_PREFIX) !== -1) {
            // 傾斜度ポリゴン
            const layerIndex = propName.slice(-1)
            const color = Constants.TRACK_COLORS[layerIndex]
            currentFeature.properties.color = color
            currentFeature.properties.layerIndex = layerIndex
            Geo.add0Point(currentFeature.geometry.coordinates)
            taskPolygons.slantsPolygon.features.push(currentFeature)
          } else if (propName === Constants.GeoJsonProp.POINT_ALL) {
            // 軌跡全ての座標
            pointAllFeature = currentFeature
          } else if (propName === Constants.GeoJsonProp.POLYGON_ALL) {
            // 軌跡全てのポリゴン
            taskPolygons.allPolygon.features.push(currentFeature)
            taskPolygons.allPolygon.features.forEach(feature => {
              const color = Constants.TRACK_FILL_COLOR
              const layerIndex = 1
              feature.properties.color = color
              feature.properties.layerIndex = layerIndex
              Geo.add0Point(currentFeature.geometry.coordinates)
            })
          }
        })

        commit(Types.SHOW_TASK_DETAIL, {
          task,
          polygonGeoJson,
          altitudes,
          maxAltitude,
          minAltitude,
          speeds,
          maxSpeed,
          minSpeed,
          gnssNumOfSatellites,
          maxGnssNumOfSatellites,
          minGnssNumOfSatellites,
          gnssStatus,
          maxGnssStatus,
          minGnssStatus,
          guidanceErrors,
          maxGuidanceErrors,
          minGuidanceErrors,
          guidanceHeadingErrors,
          maxGuidanceHeadingErrors,
          minGuidanceHeadingErrors,
          slants,
          maxSlant,
          minSlant,
          pointAllFeature,
          effectiveSpeed,
          taskPolygons,
        })

        if (!fieldOfTask) {
          // Taskに紐づく圃場がない場合は、MapCenterを算出しておく
          const centerPoint = turf.center(pointAllFeature)
          commit(Types.SET_MAP_CENTER, centerPoint.geometry.coordinates)
        }

        let showTaskDetailParams = null
        if (params.taskDetailShowAction === Constants.SHOW_TASK_DETAIL_FROM_DIRECT) {
          showTaskDetailParams = {
            key: task.geoInfoKey,
            lastModifiedDateTime: task.lastModifiedDateTime,
          }
        } else {
          showTaskDetailParams = {
            key: task.geoInfoKey,
          }
        }

        router.push({
          name: params.nextPageName,
          params: showTaskDetailParams,
        })
      })
      .catch(error => {
        console.error(error)
        router.push({
          name: 'TaskDetailError',
        })
      })
  },
*/
  showFieldDetail2({ commit }, field) {
    store.dispatch('setFieldDetail2', field)
    store.dispatch('countTasksInField', field)
    // 利用していないので、呼び出さない
    // store.dispatch('getTasksInField2', field)
    router.push({
      name: 'FieldDetail',
      params: {
        key: field.id,
      },
    })
  },

  setFieldDetail2({ commit }, field) {
    const geoJson = JSON.parse(field.geoJson)
    const fieldDetail = {
      field: field,
      geoJson: geoJson,
    }
    commit(Types.SET_FIELD_DETAIL, fieldDetail)
    const currentMapCenter = polylabel(geoJson.features[0].geometry.coordinates, 1.0)
    commit(Types.SET_MAP_CENTER, currentMapCenter)
  },

  /* navi2へ
  countTasksInField({ commit }, field) {
    connectNaviClient.countTasksForField(field).then(response => {
      const count = response.data
      commit(Types.SET_COUNT_TASKS_IN_CURRENT_FIELD, count)
    })
  },
  */

  /** @Deprecated  直近1年のみのタスク取得しかしない実装である */
  getTasksInField2({ commit }, field) {
    // tasks in fieldの取得
    const start = moment()
      .subtract(1, 'years')
      .utc() // 1年前
    const startUtc = UTCDateTime.utcStringFromMomentObject(start)
    const end = moment().utc()
    const endUtc = UTCDateTime.utcStringFromMomentObject(end)
    const pagingOptions = store.getters.pagingOptions.currentFieldTasks

    connectNaviClient
      .getTasksInField2(field, pagingOptions)
      .then(response => {
        const paginationInfoAndType = {
          type: Constants.CURRENT_FIELD_TASKS_PAGINATION_INFO_TYPE,
          info: response.data.paginationInfo,
        }
        commit(Types.SET_PAGINATION_INFO, paginationInfoAndType)

        const tasks = response.data.contents
        commit(Types.SET_CURRENT_FIELD_TASKS, tasks)
      })
      .catch(error => {
        console.error(error)
      })

    // router.push({
    //   name: 'FieldDetail',
    //   params: {
    //     key: field.geoInfoKey,
    //   },
    // })
  },

  /* navi2へ
  getAllFields({ commit }, opts) {
    commit(Types.CLEANUP_CURRENT_FILED)
    connectNaviClient
      .getFields2()
      .then(response => {
        const fields = response.data
        if (fields.length === 0) {
          if (opts) {
            if (opts.fieldEmptyAction === Constants.INIT_FIELD_OPTION_SHOW_FIELD_IMPORT) {
              router.push({ name: 'FieldListAsList' })
            }
          }
          Toast.i18nError('customErrorInitFieldsNoFields')
        }
        commit(Types.LIST_FILEDS_SUCCESS, fields)

        if (opts) {
          if (opts.taskDetailShowAction === Constants.SHOW_TASK_DETAIL_FROM_DIRECT) {
            store.dispatch('showTaskDetailFromDirect', opts)
          }
          opts.onSuccess()
        }
      })
      .catch(error => {
        console.error(error)
      })
  },
*/
  /* navi2へ
  initFields2({ commit }, opts) {
    commit(Types.CLEANUP_CURRENT_FILED)
    const params = {
      pageOptions: store.getters.pagingOptions.fields,
      sortOptions: store.getters.sortOptions.fields,
    }
    connectNaviClient
      .getFields2ForPage(params)
      .then(response => {
        const paginationInfoAndType = {
          type: Constants.FIELDS_PAGINATION_INFO_TYPE,
          info: response.data.paginationInfo,
        }
        commit(Types.SET_PAGINATION_INFO, paginationInfoAndType)
        const fields = response.data.contents
        if (fields.length === 0) {
          if (opts) {
            if (opts.fieldEmptyAction === Constants.INIT_FIELD_OPTION_SHOW_FIELD_IMPORT) {
              // store.dispatch('setListViewMode', { view: 'field', mode: Constants.LIST_VIEW_MODE_APPEND })
              // router.push({ name: 'FieldList' })
              router.push({
                name: 'FieldListAsList',
              })
            }
          }
          const path = location.pathname
          const pathArray = path.split('/')
          if (pathArray[1] !== 'enterprise') {
            Toast.i18nError('customErrorInitFieldsNoFields')
          }
        }
        commit(Types.LIST_FILEDS_SUCCESS, fields)

        // 昨付も取得
        store.dispatch('initPlantings')
      })
      .catch(error => {
        console.error(error)
      })
  },
*/

  /** @deprecated */
  updateTaskNameInList({ commit }, updateRequest) {
    commit(Types.UPDATE_TASK_NAME_IN_LIST, updateRequest)
    const index = updateRequest.index
    const targetTask = state.tasks[index]
    const request = {
      name: updateRequest.value,
    }
    connectNaviClient
      .updateTaskMetaData(targetTask, request)
      .then(response => {
// TEMP         console.log(response)
      })
      .catch(error => {
        console.error(error)
      })
  },

  /** @deprecated */
  updateListingUserOfTaskList({ commit }, listingUser) {
    commit(Types.UPDATE_LISTING_USER_OF_TASK_LIST, listingUser)
    store.dispatch('initTasks2')
  },

  updatePagingOfTaskList({ commit }, opts) {
    const pagingOptions = opts.pagingOptions
    commit(Types.UPDATE_PAGING_OPTIONS_OF_TASK_LIST, pagingOptions)
    store.dispatch('initTasksWithFilter', opts)
  },
  /* navi2へ
  initTasksWithFilter({ commit }, opts) {
    let pagingOptions = opts.pagingOptions
    if (!pagingOptions) {
      pagingOptions = store.getters.pagingOptions.tasks
    }
    let filter = opts.taskFilter
    if (!UserInfo.hasStandardFunctionality()) {
      const freePlanRetentionPeriod = moment()
        .subtract(Constants.HOURS_FOR_TASK_RECORD_RETENTION_PERIOD_FOR_FREE_PLAN, 'hours')
        .utc()
      filter.dateTimeRange.from = freePlanRetentionPeriod
    }
    connectNaviClient
      .getTasksWithFilter(filter, pagingOptions)
      .then(response => {
        const paginationInfoAndType = {
          type: Constants.TASKS_PAGINATION_INFO_TYPE,
          info: response.data.paginationInfo,
        }
        commit(Types.SET_PAGINATION_INFO, paginationInfoAndType)
        let tasks = response.data.contents
        // 場合によっては表示件数がゼロになってしまうので、警告を出す。
        if (tasks.length === 0) {
          if (!UserInfo.hasStandardFunctionality()) {
            Toast.i18nError('customErrorInitTasksFreePlan')
          } else {
            if (filter.filterName === i18n.tt('customTaskFilterAllSelect')) {
              Toast.i18nError('customErrorInitTasksNoTasks')
            } else {
              Toast.i18nError('customTaskFilterNoTasksError', { filtername: filter.filterName })
            }
          }
        }
        commit(Types.LIST_TASKS_SUCCESS, tasks)
        commit(Types.CLEANUP_CURRENT_TASK)
      })
      .catch(error => {
        console.error(error)
      })
  },
*/
  updatePagingOfFieldList({ commit }, opts) {
    const pagingOptions = opts.pagingOptions
    commit(Types.UPDATE_PAGING_OPTIONS_OF_FIELD_LIST, pagingOptions)
    store.dispatch('initFields2', opts)
  },

  /** @deprecated */
  initTasksBetween({ commit }, request) {
    const calendarCurrent = request.current
    connectNaviClient
      .getAllTasksBetween(request.from, request.to, request.listingUser)
      .then(response => {
        let tasks = response.data
        commit(Types.LIST_TASKS_SUCCESS, tasks)
        commit(Types.CLEANUP_CURRENT_TASK)
        commit(Types.SET_TASK_LIST_CURRENT_CALENDAR_MONTH, calendarCurrent)
      })
      .catch(error => {
        console.error(error)
      })
  },

  /** @deprecated */
  initTasks2({ commit }) {
    const pagingOptions = store.getters.pagingOptions.tasks
    connectNaviClient
      .getTasks2(pagingOptions)
      .then(response => {
        let subtractHours = Constants.HOURS_FOR_TASK_RECORD_RETENTION_PERIOD_FOR_STANDARD_PLAN
        if (UserInfo.hasFreeFunctionality()) {
          subtractHours = Constants.HOURS_FOR_TASK_RECORD_RETENTION_PERIOD_FOR_FREE_PLAN
        }
        const oldestDateUtc = moment()
          .subtract(subtractHours, 'hours')
          .utc()

        const paginationInfoAndType = {
          type: Constants.TASKS_PAGINATION_INFO_TYPE,
          info: response.data.paginationInfo,
        }
        commit(Types.SET_PAGINATION_INFO, paginationInfoAndType)

        let tasks = response.data.contents
        tasks = tasks.filter((task, index, array) => {
          const createdAt = UTCDateTime.toUtcMoment(task.createdDateTime)
          return createdAt >= oldestDateUtc
        })
        // フリープランの場合、場合によっては表示件数がゼロになってしまうので、警告を出す。
        if (tasks.length === 0) {
          if (UserInfo.hasFreeFunctionality()) {
            Toast.i18nError('customErrorInitTasksFreePlan')
          } else {
            // 同期を促すメッセージの表示を廃止 https://github.com/agri-info-design/connect-servers/issues/1112
            // Toast.i18nError('customErrorInitTasksNoTasks')
          }
        }

        commit(Types.LIST_TASKS_SUCCESS, tasks)
        commit(Types.CLEANUP_CURRENT_TASK)
      })
      .catch(error => {
        console.error(error)
      })
  },

  /** @deprecated */
  // initFields({ commit }) {
  //   connectNaviClient
  //     .getFields()
  //     .then(response => {
  //       const fields = response.data
  //       if (fields.length === 0) {
  //         Toast.i18nError('customErrorInitFieldsNoFields')
  //       }
  //       commit(Types.LIST_FILEDS_SUCCESS, fields)
  //       commit(Types.CLEANUP_CURRENT_FILED)
  //     })
  //     .catch(error => {
  //       console.error(error)
  //     })
  // },

  _getFieldGeoJson(
    { commit },
    field,
    opts = {
      goToDetailPage: false,
    }
  ) {
    connectNaviClient
      .getFieldGeoJson(field)
      .then(response => {
        const geoJson = JSON.parse(response.data)
        const fieldDetail = {
          field: field,
          geoJson: geoJson,
        }
        commit(Types.SET_FIELD_DETAIL, fieldDetail)

        const currentMapCenter = polylabel(geoJson.features[0].geometry.coordinates, 1.0)
        commit(Types.SET_MAP_CENTER, currentMapCenter)

        if (opts && opts.goToDetailPage) {
          router.push({
            name: 'FieldDetail',
            params: {
              key: field.id,
            },
          })
        }
      })
      .catch(error => {
        console.error(error)
      })
  },

  /** @deprecated */
  showFieldDetail({ commit }, field) {
    // 1. tasks in fieldの取得
    const end = moment().utc()
    const start = moment()
      .subtract(1, 'years')
      .utc() // 1年前
    connectNaviClient
      .getTasksInField(field, UTCDateTime.utcStringFromMomentObject(start), UTCDateTime.utcStringFromMomentObject(end))
      .then(response => {
        const tasks = response.data
        commit(Types.SET_CURRENT_FIELD_TASKS, tasks)
      })
      .catch(error => {
        console.error(error)
      })

    // 2. fieldに紐づくTask Geo JSONS
    actions._getFieldGeoJson(
      {
        commit,
      },
      field,
      {
        goToDetailPage: true,
      }
    )
  },

  /** @deprecated */
  initTasks({ commit }) {
    connectNaviClient
      .getTasks()
      .then(response => {
        let subtractHours = Constants.HOURS_FOR_TASK_RECORD_RETENTION_PERIOD_FOR_STANDARD_PLAN
        if (UserInfo.hasFreeFunctionality()) {
          subtractHours = Constants.HOURS_FOR_TASK_RECORD_RETENTION_PERIOD_FOR_FREE_PLAN
        }
        const oldestDateUtc = moment()
          .subtract(subtractHours, 'hours')
          .utc()
        let tasks = response.data
        tasks = tasks.filter((task, index, array) => {
          const createdAt = UTCDateTime.toUtcMoment(task.createdDateTime)
          return createdAt >= oldestDateUtc
        })
        // tasks = tasks.reverse()
        // フリープランの場合、場合によっては表示件数がゼロになってしまうので、警告を出す。
        if (tasks.length === 0) {
          if (UserInfo.hasFreeFunctionality()) {
            Toast.i18nError('customErrorInitTasksFreePlan')
          } else {
            // 同期を促すメッセージの表示を廃止 https://github.com/agri-info-design/connect-servers/issues/1112
            // Toast.i18nError('customErrorInitTasksNoTasks')
          }
        }
        commit(Types.LIST_TASKS_SUCCESS, tasks)
        commit(Types.CLEANUP_CURRENT_TASK)
      })
      .catch(error => {
        console.error(error)
      })
  },
  /* navi2へ
  showTaskDetailFromDirect({ commit }, opts) {
    connectNaviClient
      .getTaskRecordItem(opts)
      .then(response => {
        const task = response.data
        const params = {
          task: task,
          nextPageName: 'TaskDetailDirect',
          taskDetailShowAction: opts.taskDetailShowAction,
        }
        store.dispatch('showTaskDetail2', params)
      })
      .catch(error => {
        console.error(error)
        router.push({
          name: 'TaskDetailError',
        })
      })
  },
  */

  /** @deprecated */
  showAllTasksInField({ commit, state }, fieldInfo) {
    connectNaviClient
      .getTaskGeoJsonsInField(fieldInfo.field, fieldInfo.start, fieldInfo.end)
      .then(response => {
        const allTasksGeoJson = JSON.parse(response.data)
        commit(Types.SHOW_TASKS_IN_FILED_WITH_MAP, {
          field: fieldInfo.field,
          geoJson: allTasksGeoJson,
        })

        const currentMapCenter = polylabel(state.currentFieldGeoJson.features[0].geometry.coordinates, 1.0)
        commit(Types.SET_MAP_CENTER, currentMapCenter)

        const selectedDate = fieldInfo.selectedDate.format(ApplicationConfig.getUserDateMomentFormat())

        // allTaskGeoJsonのチェック
        const features = allTasksGeoJson.features
        if (features) {
          let polygonCounts = features
            .map(feature => {
              return feature.geometry.coordinates.length
            })
            .reduce((previousValue, currentValue) => {
              return previousValue + currentValue
            })
          if (polygonCounts === 0) {
            Toast.i18nError('customTaskNotFoundAtDate', {
              date: selectedDate,
            })
          }
        }

        router.push({
          name: 'TasksInField',
        })
      })
      .catch(error => {
        console.error(error)
      })
  },
  setDateFilterRange({ commit }, params) {
    commit(Types.SET_DATE_FILTER_RANGE, params)
  },
  /* navi2へ
  initRefLines({ commit }) {
    const pagingOptions = store.getters.pagingOptions.refLines
    connectNaviClient.listRefLines(pagingOptions).then(response => {
      const paginationInfoAndType = {
        type: Constants.REFLINES_PAGINATION_INFO_TYPE,
        info: response.data.paginationInfo,
      }
      commit(Types.SET_PAGINATION_INFO, paginationInfoAndType)
      commit(Types.SET_REFLINES, response.data.contents)
    })
  },
  */
  updatePagingOfRefLinesList({ commit }, opts) {
    const pagingOptions = opts.pagingOptions
    commit(Types.UPDATE_PAGING_OPTIONS_OF_REFLINES_LIST, pagingOptions)
    store.dispatch('initRefLines')
  },

  /* navi2へ
  showRefLineDetail({ commit }, refLine) {
    connectNaviClient
      .getRefLineGeoJson(refLine)
      .then(response => {
        const item = { item: refLine, geoJson: response.data }
        commit(Types.SET_CURRENT_REFLINE, item)
        router.push({
          name: 'RefLineDetail',
          params: {
            key: refLine.geoInfoKey,
          },
        })
      })
      .catch(error => {
        console.error(error)
        if (error.response) {
          const responseData = error.response.data
          if (responseData) {
            Toast.error(responseData.message)
          }
        } else {
          Toast.i18nError('customNotAvailable')
        }
      })
  },
  */
  /* navi2へ
  updateRefLineMetaData({ commit }, updateRequest) {
    connectNaviClient
      .updateRefLineMetaData(updateRequest)
      .then(response => {
        const item = { item: response.data, geoJson: updateRequest.geoJson }
        commit(Types.SET_CURRENT_REFLINE, item)
      })
      .catch(error => {
        console.error(error)
      })
  },
  */
  /* navi2へ
  deleteRefLine({ commit }, refLine) {
    connectNaviClient
      .deleteRefLine(refLine)
      .then(response => {
        store.dispatch('initRefLines')
      })
      .catch(error => {
        Toast.i18nError('customRefLineDeleteError')

        console.error(error)
      })
  },
  */

  setCurrentFilter({ commit }, filter) {
    commit(Types.SET_CURRENT_FILTER, filter)
  },
  /* navi2へ
  getCentroidOfUserFields({ commit }) {
    connectNaviClient
      .getCentroidOfUserFields()
      .then(response => {
        const point = response.data
        if (point) {
          commit(Types.SET_CENTROID_OF_USER_FIELDS, point)
          // FIXME Grow
          const coord = turf.getCoord(point)
          store.dispatch('initGrowCrops', { lat: coord[0], lon: coord[1] })
        } else {
          // 圃場中心がない、という結果がサーバーから返された場合、デフォルトエリア
          store.dispatch('initGrowCrops', { lat: 0, lon: 0 })
        }
      })
      .catch(error => {
        // 圃場そのものが見つからない場合、デフォルトエリア
        store.dispatch('initGrowCrops', { lat: 0, lon: 0 })
      })
  },
  */
  /* navi2へ
  deleteTaskRecordItem({ commit }, params) {
    const task = params.task
    connectNaviClient
      .deleteTaskRecordItem(task.geoInfoKey)
      .then(response => {
        params.onSuccess()
      })
      .catch(error => {
        console.error(error)
        params.onFailure()
      })
  },
  */
  /* navi2へ
  listPfObservations({ commit }) {
    connectNaviClient
      .listPfObservations()
      .then(response => {
        const observations = response.data
        commit(Types.SET_PF_OBSERVATIONS, observations)
        // PF値をGrowServerに取得
        for (let i = 0; i < observations.length; i++) {
          const o = observations[i]
          store.dispatch('growGetSoilMoisture', o)
        }
      })
      .catch(error => console.error(error))
  },

  createPfObservation({ commit }, params) {
    connectNaviClient
      .createPfObservation(params.request)
      .then(response => {
        store.dispatch('listPfObservations')
        params.onSuccess()
      })
      .catch(error => {
        console.error()
        params.onFailure()
      })
  },

  updatePfObservation({ commit }, params) {
    connectNaviClient
      .updatePfObservation(params.request)
      .then(response => {
        store.dispatch('listPfObservations')
        params.onSuccess()
      })
      .catch(error => {
        console.error()
        params.onFailure()
      })
  },

  deletePfObservation({ commit }, params) {
    connectNaviClient
      .deletePfObservation(params.request)
      .then(response => {
        store.dispatch('listPfObservations')
        params.onSuccess()
      })
      .catch(error => {
        console.error()
        params.onFailure()
      })
  },
  */
  /* navi2へ
  listAtObservations({ commit }) {
    connectNaviClient
      .listAtObservations()
      .then(response => {
        const observations = response.data
        commit(Types.SET_AT_OBSERVATIONS, observations)
        // AT値をGrowServerに取得
        for (let i = 0; i < observations.length; i++) {
          const o = observations[i]
          store.dispatch('growGetAccumulatedTemperature', o)
        }
      })
      .catch(error => console.error(error))
  },

  createAtObservation({ commit }, params) {
    connectNaviClient
      .createAtObservation(params.request)
      .then(response => {
        store.dispatch('listAtObservations')
        params.onSuccess()
      })
      .catch(error => {
        console.error()
        params.onFailure()
      })
  },

  updateAtObservation({ commit }, params) {
    connectNaviClient
      .updateAtObservation(params.request)
      .then(response => {
        store.dispatch('listAtObservations')
        params.onSuccess()
      })
      .catch(error => {
        console.error()
        params.onFailure()
      })
  },

  deleteAtObservation({ commit }, params) {
    connectNaviClient
      .deleteAtObservation(params.request)
      .then(response => {
        store.dispatch('listAtObservations')
        params.onSuccess()
      })
      .catch(error => {
        console.error()
        params.onFailure()
      })
  },
  */
  /* navi2へ
  updateFieldPolygon({ commit }, request) {
    connectNaviClient
      .updateFieldPolygon(request)
      .then(response => {
        const field = response.data
        request.onSuccess(field)
      })
      .catch(error => {
        request.onFailure()
        console.error()
      })
  },
  */
  changeSortOrderItem({ commit }, params) {
    commit(Types.SET_LIST_FIELD_SORT_OPTIONS, params)
    store.dispatch('initFields2')
  },

  /**
   * 高低差マップ取得
   */
  /* navi2へ
  getFieldElevationMap({ commit }, params) {
    const field = params.field
    connectNaviClient
      .getFieldElevationMap(field)
      .then(response => {
        const map = response.data
        commit(Types.SET_CURRENT_FIELD_ELEVATION_MAP, map)
        const onSuccess = params.onSuccess
        if (onSuccess) {
          onSuccess()
        }
      })
      .catch(error => {
        if (error.status === 404) {
          commit(Types.CLEANUP_CURRENT_FILED_ELEVATION_MAP)
        } else {
          console.error(error)
        }
      })
  },
  */

  /**
   * 高低差マップ情報をメモリから消去
   */
  clearCurrentFieldElevationMap({ commit }) {
    commit(Types.CLEANUP_CURRENT_FILED_ELEVATION_MAP)
  } /*
  createFieldElevationMap({ commit }, params) {
    // statusをCreatingにしておく
    let map = { status: 'Creating' }
    commit(Types.SET_CURRENT_FIELD_ELEVATION_MAP, map)
    connectNaviClient
      .createFieldElevationMap(params)
      .then(response => {
        map = response.data
        commit(Types.SET_CURRENT_FIELD_ELEVATION_MAP, map)
        const onSuccess = params.onSuccess
        if (onSuccess) {
          onSuccess()
        }
      })
      .catch(error => {
        const onFailure = params.onFailure
        if (onFailure) {
          onFailure(error)
        }
        console.error(error)
      })
  },*/,

  /**
   * 高低差マップ作成
   */
}

export default {
  state,
  getters,
  mutations,
  actions,
}
